const initialState = {
  fetching: false,
  fetched: false,
  data: null,
  error: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_LISTING_SEARCH':
      return initialState

    case 'FETCH_LISTING_SEARCH_RESULTS_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'FETCH_LISTING_SEARCH_RESULTS_REJECTED':
      return {
        ...state,
        fetching: true,
        error: action.payload,
      }

    case 'FETCH_LISTING_SEARCH_RESULTS_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload,
      }

    case 'UPDATE_LISTING_SEARCH_RESULTS_FULFILLED':
      return {
        ...state,
        data: action.payload,
      }

    default:
      return state
  }
}
